module.exports = __webpack_public_path__ + "img/169.aa24f159.jpg";